import { notification } from '../../../components/Notifications'

interface ReopenSurveySuccessDeps {
  refreshSections: () => void
  refreshLiveView: () => void
}

interface ReopenSurveyVariables {
  wasLastClosedSection?: boolean
}

/**
 * Success handler for the row-level Reopen Survey mutation.
 *
 * A reopened section returns to Live/Published and leaves the Closed view. Refresh target
 * depends on `variables.wasLastClosedSection`: reopening the only section in the current
 * (Closed) view empties it, so we switch to the Live & Upcoming view (`refreshLiveView`)
 * instead of refetching the now-empty Closed view (`refreshSections`).
 */
export const createReopenSurveySuccessHandler = ({ refreshSections, refreshLiveView }: ReopenSurveySuccessDeps) =>
  (data: any, variables?: ReopenSurveyVariables): void => {
    notification(data?.data?.message ?? 'Survey reopened successfully', { variant: 'success' })
    const refresh = variables?.wasLastClosedSection === true ? refreshLiveView : refreshSections
    refresh()
  }
